export const TITLE = 'call_center.login.title';
export const SUBMIT = 'call_center.login.submit';
export const SUBMIT_LOADING = 'call_center.login.submit_loading';
export const USERNAME = 'call_center.login.username';
export const PASSWORD = 'call_center.login.password';
export const ERROR_EMPTY_FIELDS = 'call_center.login.error.empty_fields_alert';
export const ERROR_EMPTY_FIELD = 'call_center.login.error.empty_field';
export const ERROR_INVALID_FIELDS = 'call_center.login.error.invalid_fields';
